import { render } from "./TopicTeasers.vue?vue&type=template&id=79ffc4ae"
import script from "./TopicTeasers.vue?vue&type=script&lang=js"
export * from "./TopicTeasers.vue?vue&type=script&lang=js"

import "./TopicTeasers.vue?vue&type=style&index=0&id=79ffc4ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__